import { render, staticRenderFns } from "./Default_page.vue?vue&type=template&id=5c40f652&"
import script from "./Default_page.vue?vue&type=script&lang=js&"
export * from "./Default_page.vue?vue&type=script&lang=js&"
import style0 from "./Default_page.vue?vue&type=style&index=0&id=5c40f652&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports